'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('react-stepzilla/dist/main');

var _main2 = _interopRequireDefault(_main);

var _Header = require('../Header');

var _Header2 = _interopRequireDefault(_Header);

var _Card = require('../Card');

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Wizard = function (_Component) {
  _inherits(Wizard, _Component);

  function Wizard(props) {
    _classCallCheck(this, Wizard);

    var _this = _possibleConstructorReturn(this, (Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call(this, props));

    _this.state = {};
    _this.onStepChange = _this.onStepChange.bind(_this);
    return _this;
  }

  _createClass(Wizard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          startAtStep = _props.startAtStep,
          steps = _props.steps;

      this.setState({ currentItem: steps[startAtStep].name });
    }
  }, {
    key: 'onStepChange',
    value: function onStepChange(step) {
      var _props2 = this.props,
          steps = _props2.steps,
          onStepChange = _props2.onStepChange;

      this.setState({ currentItem: steps[step].name });
      onStepChange({ step: step });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          showNavigation = _props3.showNavigation,
          showHeaderBorder = _props3.showHeaderBorder,
          prevBtnOnLastStep = _props3.prevBtnOnLastStep,
          dontValidate = _props3.dontValidate,
          preventEnterSubmission = _props3.preventEnterSubmission,
          startAtStep = _props3.startAtStep,
          nextButtonText = _props3.nextButtonText,
          backButtonText = _props3.backButtonText,
          nextButtonCls = _props3.nextButtonCls,
          backButtonCls = _props3.backButtonCls,
          nextTextOnFinalActionStep = _props3.nextTextOnFinalActionStep,
          hocValidationAppliedTo = _props3.hocValidationAppliedTo,
          contentAlign = _props3.contentAlign,
          showHeader = _props3.showHeader,
          steps = _props3.steps;
      var currentItem = this.state.currentItem;

      return _react2.default.createElement(
        'div',
        { className: 'Wizard' },
        _react2.default.createElement(
          _Card2.default,
          { contentAlign: contentAlign },
          showHeader && _react2.default.createElement(
            _Header2.default,
            { type: 'h5', className: 'pb-3', borderBottom: showHeaderBorder },
            currentItem
          ),
          _react2.default.createElement(_main2.default, {
            showNavigation: showNavigation,
            showSteps: false,
            stepsNavigation: false,
            prevBtnOnLastStep: prevBtnOnLastStep,
            dontValidate: dontValidate,
            preventEnterSubmission: preventEnterSubmission,
            startAtStep: startAtStep,
            nextButtonText: nextButtonText,
            backButtonText: backButtonText,
            nextButtonCls: nextButtonCls,
            backButtonCls: backButtonCls,
            nextTextOnFinalActionStep: nextTextOnFinalActionStep,
            hocValidationAppliedTo: hocValidationAppliedTo,
            steps: steps,
            onStepChange: this.onStepChange
          })
        )
      );
    }
  }]);

  return Wizard;
}(_react.Component);

Wizard.propTypes = {
  showHeader: _propTypes2.default.bool,
  showHeaderBorder: _propTypes2.default.bool,
  showNavigation: _propTypes2.default.bool,
  prevBtnOnLastStep: _propTypes2.default.bool,
  dontValidate: _propTypes2.default.bool,
  preventEnterSubmission: _propTypes2.default.bool,
  startAtStep: _propTypes2.default.number,
  nextButtonText: _propTypes2.default.string,
  backButtonText: _propTypes2.default.string,
  nextButtonCls: _propTypes2.default.string,
  backButtonCls: _propTypes2.default.string,
  nextTextOnFinalActionStep: _propTypes2.default.string,
  contentAlign: _propTypes2.default.string,
  hocValidationAppliedTo: _propTypes2.default.arrayOf(_propTypes2.default.number),
  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    component: _propTypes2.default.element.isRequired
  })).isRequired,
  onStepChange: _propTypes2.default.func
};
Wizard.defaultProps = {
  showHeader: true,
  showHeaderBorder: true,
  showNavigation: true,
  prevBtnOnLastStep: true,
  dontValidate: true,
  preventEnterSubmission: true,
  startAtStep: 0,
  nextButtonText: 'Next',
  backButtonText: 'Back',
  nextButtonCls: 'btn btn-primary pull-right',
  backButtonCls: 'btn btn-primary pull-left',
  nextTextOnFinalActionStep: 'Next',
  contentAlign: 'left',
  hocValidationAppliedTo: [],
  onStepChange: function onStepChange() {}
};

exports.default = Wizard;